import React, { useState, useEffect } from "react";
import { routes } from "../../router/paths";
import { Logo, Title } from "../../components/atoms";
// import { LoginForm } from "../../components/organisms";
import Actions from "../../store/actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AnalyticsService } from "../../utils/Analytics";
import { ResetPasswordForm } from "../../components/organisms/ResetPasswordForm/ResetPasswordForm";

const ResetPassword = (props) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const[resetCode, setResetCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);  
  const [isNewPassVisible, setIsNewPassVisible] = useState(true);
  const [isConfirmNewPassVisible, setIsConfirmNewPassVisible] = useState(true);
  // const { paramEmail, paramCode } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();


  useEffect(() => {
    
    const paramEmail = searchParams.get("email");
    const paramCode = searchParams.get("code");
    setEmail(paramEmail);
    setResetCode(paramCode);
    console.log("email:", searchParams.get("email"), "code: ", paramCode);
  }, [searchParams]);
  
  const onChangeNewPassword = (e) => {
    setNewPassword(e.target.value);
  };
  const onChangeConfirmNewPassword = (e) => {
        
      setConfirmNewPassword(e.target.value);    
  }; 

  const toggleNewPassword = () => {
      setIsNewPassVisible(!isNewPassVisible);
  };
  const toggleConfirmNewPassword = () => {
    setIsConfirmNewPassVisible(!isConfirmNewPassVisible);
  };
  const validateEmail = (emailAddress) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailAddress)) {
      return true;
    }
    return false;
  };

  const ResetPasswordAction = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const { actions } = props;
    if (email !== "" && newPassword !== "") {
      const response = await actions.resetPassword({
        Email: email,
        Code: resetCode,        
        Password : newPassword,
        ConfirmPassword : confirmNewPassword,
      });
      if (response && response.success === true) {
        alert("Password successfully reset, please login")
        navigate(routes.login);
        
        setLoading(true);
      } else {
        setError(
          response && response.message
            ? response.message
            : "Internal server error"
        );
        setLoading(false);
        AnalyticsService.logEvent("USER_RESETPASSWORD_IN_ERROR", {
          Error:
            response && response.message
              ? response.message
              : "Internal server error",
        });
      }
    } else {
      setError("");
    }
  };

  return (
    <div className="flexPanel">
      <div className="leftPanel">
        <Logo />
        <Title text="The Cricket Store" className={"titleDefaultCls"} />
        <Title text="Merchant's Portal" className="subTitleCls" />
      </div>
      <div className="rightPanel">
        <div className="form-container">
          <Title text="Change Password" className={"titleDefaultCls"} />
          <Title text="" className={"titleDefaultCls"} />
          
          <ResetPasswordForm
            ResetPasswordAction={ResetPasswordAction}                     
            onChangeConfirmPassword = {onChangeConfirmNewPassword}
            onChangeNewPassword={onChangeNewPassword}
            email={email}           
            newPassword={ newPassword}
            confirmNewPassword={ confirmNewPassword}
            isSubmit={isSubmit}
            validateEmail={validateEmail}
            errorMessage={error}           
            toggleNewPassword={toggleNewPassword}
            toggleConfirmNewPassword={toggleConfirmNewPassword}            
            isNewPassVisible={isNewPassVisible}
            isConfirmNewPassVisible={isConfirmNewPassVisible}
            isLoading={loading}
          />
        </div>
      </div>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(ResetPassword);
